import { create } from 'zustand';
import type { Product } from '../services/products/products.service';

interface ProductDrawerState {
  isOpen: boolean;
  isMinimized: boolean;
  productToEdit: Product | null;
  openCreate: () => void;
  openEdit: (product: Product) => void;
  minimize: () => void;
  maximize: () => void;
  close: () => void;
}

export const useProductDrawerStore = create<ProductDrawerState>((set) => ({
  isOpen: false,
  isMinimized: false,
  productToEdit: null,
  openCreate: () => set({ isOpen: true, isMinimized: false, productToEdit: null }),
  openEdit: (product) => set({ isOpen: true, isMinimized: false, productToEdit: product }),
  minimize: () => set({ isMinimized: true }),
  maximize: () => set({ isMinimized: false }),
  close: () => set({ isOpen: false, isMinimized: false, productToEdit: null }),
}));
